import { useMemo } from 'react';
import { RichTextRenderer } from '@knack/asterisk-react';

import { type LiveAppPageFull } from '@/types/schema/LiveAppPage';
import { usePageModal } from '@/hooks/usePageModal';
import { sanitizeHTML } from '@/utils/sanitizeHTML';
import { PagePrint } from './PagePrint';

export function PageTitle({ page }: { page: LiveAppPageFull }) {
  const { isPageRenderedAsModal } = usePageModal();
  const sanitizedName = useMemo(() => sanitizeHTML(page.name || ''), [page.name]);

  if (page.type === 'authentication' || !page.isTitleVisible || isPageRenderedAsModal) {
    return null;
  }

  return (
    <h1 className="kn-page-title flex items-center gap-2 text-2xl print:hidden">
      <RichTextRenderer dangerouslySetInnerHTML={{ __html: sanitizedName }} />
      {page.print && <PagePrint />}
    </h1>
  );
}
